import imgStepPerson from "../assets/svg/imgStepPerson.svg";
import shareholdersIconStep from "../assets/svg/shareholdersIconStep.svg";
import iconProductServiceStep from "../assets/svg/iconProductServiceStep.svg";
import bankingIconStep from "../assets/svg/bankingIconStep.svg";
import FactorStepIcon from "../assets/svg/FactorStepIcon.svg";
import Start from "../assets/svg/Start.svg";

export const guideTabs = [
    {
        title: "شروع",
        time: "",
        width: null,
        level: 1,
        guide: {
            title: "شروع کار با چرتکه",
            img: Start,
            description:
                "جهت شروع کار با نرم افزار حسابداری، ابتدا باید اطلاعات مورد نیاز کسب و کار خود را تعریف نمایید. این مراحل در ادامه توضیح داده شده اند.",
        },
    },
    {
        title: "اشخاص",
        time: "",
        width: null,
        level: 2,
        guide: {
            title: "ثبت اشخاص",
            img: imgStepPerson,
            description:
                "اولین مرحله، تعریف اشخاص طرف حساب کسب و کار شماست. این اشخاص شامل مشتریان، کارمندان، فروشندگان و تامین کنندگان شما هستند.",
            textButton: "ثبت شخص جدید",
            link: "/persons/add",
            videos: [
                {
                    title: "آموزش ثبت و مدیریت اشخاص",
                    thumbnail: "https://www.chortke.app/wp-content/uploads/2023/03/ashkhas-min.jpg.webp",
                    url: "https://www.chortke.app/wp-content/uploads/2023/03/ashkhas.mp4",
                    questions: ["تعریف شخص جدید", "لیست مشتریان و فروشندگان", "جستجو و فیلتر کردن اشخاص"],
                },
            ],
        },
    },
    {
        title: "سهامداران",
        time: "",
        width: null,
        level: 3,
        guide: {
            title: "ثبت سهامداران",
            img: shareholdersIconStep,
            description:
                "سهامداران اشخاصی هستند که در کسب و کار شما سرمایه گذاری کرده اند یا سهم سود و زیاد دارند. سهامداران از بین اشخاص با نقش کارمند قابل انتخاب میباشند",
            textButton: "ثبت سهامداران",
            link: "/shareholders",
        },
    },
    {
        title: "کالا/خدمات",
        time: "",
        width: null,
        level: 4,
        guide: {
            title: "ثبت کالاها و خدمات",
            img: iconProductServiceStep,
            description:
                "قدم بعدی ثبت کالا و خدمات شماست. محصول شامل محصولات فیزیکی مانند تلفن همراه، و خدمات شامل محصولات غیر فیزیکی مانند تعمیرات می باشد",
            textButton: "افزودن کالا/ خدمات",
            link: "/products/add",
            videos: [
                {
                    title: "آموزش ثبت و مدیریت محصولات",
                    thumbnail: "https://www.chortke.app/wp-content/uploads/2023/03/Mahsolat-min.jpg.webp",
                    url: "https://www.chortke.app/wp-content/uploads/2023/03/Mahsolat.mp4",
                    questions: ["تعریف محصول جدید", "لیست محصولات و خدمات", "جستجو و فیلتر کردن محصولات"],
                },
            ],
        },
    },
    {
        title: "بانکداری",
        time: "",
        width: null,
        level: 5,
        guide: {
            title: "ثبت حساب ها",
            img: bankingIconStep,
            description:
                "مرحله بعدی ثبت حساب های مالی کسب و کار شماست، این حسابها شامل حساب های بانکی، تنخواه گردان و صندوق های فروش کسب و کار شما می باشند",
            textButton: "افزودن حساب",
            link: "/financials/add",
            videos: [
                {
                    title: "آموزش عملیات بانکداری و ثبت حساب",
                    thumbnail: "https://www.chortke.app/wp-content/uploads/2023/03/afzoodan-min.jpg.webp",
                    url: "https://www.chortke.app/wp-content/uploads/2023/03/Afzodan-hesab_eslah-shode-1.mp4",
                    questions: [
                        "تعریف حساب بانکی",
                        "تعریف حساب تنخواه گردان",
                        "تعریف حساب صندوق",
                        "ویرایش و حذف حساب ها",
                    ],
                },
            ],
        },
    },
    {
        title: "پایان",
        time: "",
        width: "86px",
        line: false,
        level: 6,
        guide: {
            title: "فاکتور شما آماده است!",
            img: FactorStepIcon,
            description:
                "هم اکنون می توانید اولین فاکتور خود را ثبت کنید. در صورت سوال یا ابهام در مورد نرم افزار راهنمای کاربران را مطالعه کنید یا با پشتیبانی در تماس باشید.",
            textButton: "ثبت فاکتور",
            link: "/factors/add",
        },
    },
];
